export const getAxiosLink = () => {
    const myAPILink =   "https://safe-fjord-90688.herokuapp.com/api"
// const myAPILink = "http://localhost:8080/api";

    return myAPILink;
}
